// Maps paths that should point their canonical tag at a different URL.
// /quote and /get-a-quote both exist — /quote canonicalizes to /get-a-quote.
export const CANONICALS: Record<string, string> = {
  '/quote': '/get-a-quote',
};
